import { render, staticRenderFns } from "./page011.vue?vue&type=template&id=137d95f6&scoped=true&"
import script from "./page011.vue?vue&type=script&lang=js&"
export * from "./page011.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137d95f6",
  null
  
)

export default component.exports